import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_get_material_soft_allocations_by_materialId_warehouseId_packagedIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { materialId: number, packagedId: number, warehouseId: number }): 
  Promise<{ result: { TotalSoftPackagedAmount?: number, ExpectedPackagedId?: number, OrderLine?: { MaterialId?: number }, Shipment?: { ExpectedWarehouseId?: number } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil($inParams.packagedId)) {
      $missingRequiredInParams.push('\'packagedId\'');
    }
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      materialId: number, packagedId: number, warehouseId: number    }) {
        if(isNil($inParams.materialId)) {
          return true; 
        }
        if(isNil($inParams.packagedId)) {
          return true; 
        }
        if(isNil($inParams.warehouseId)) {
          return true; 
        }
      return false;
    }
}
